/* **************************************************** Kitchen range */
export interface FSKitchenRange {
    id: number;
    brand_id: number | null;
    collection_id: number | null;
    range_name: string;
    created_by: number | null;
}

export const mapFSKitchenRange = (data: any): FSKitchenRange => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchenRange = {
        id: data.id,
        brand_id: data.brand_id || null,
        collection_id: data.collection_id || null,
        range_name: data.range_name,
        created_by: data.created_by || null
    };

    return res;
};

export const mapFSKitchenRanges = (data: any[]): FSKitchenRange[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchenRange);
};